import { DotsAnimation } from '@/components/DotsAnimation'

export const Loading = ({ top = 0 }: { top?: number }) => (
  <div className="animate-fade-in absolute left-0 z-50 flex h-full w-full items-center justify-center bg-white/50" style={{ top }}>
    <DotsAnimation className="text-primary h-96 w-96" />
  </div>
)
